import { MyProfileAvatar } from '@/components/my-profile-avatar';
import { QuickActionsNav } from '@/components/quick-actions-nav';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Button } from '@/components/ui/button';
import { SmartMeterMenuPopover } from '@/features/devices/components/smart-meter/smart-meter-menu-popover.tsx';
import { useGetDeviceQuery } from '@/features/devices/hooks/queries/[device]/get-device.ts';
import { useMediaQuery } from '@/hooks/use-media-query';
import { ChevronLeft } from 'lucide-react';
import { Link, useParams } from 'react-router';
import { DefaultDevicePage } from '@/pages/devices/[device]/default-device.page.tsx';
import { BmsDevicePage } from '@/pages/devices/[device]/bms-device.page.tsx';
import { useGetPlantQuery } from '@/features/plants/hooks/queries/[plantId]/use-get-plant.ts';

const DevicePlant = () => {
  const isMobile = useMediaQuery('(max-width:640px)');
  const { deviceId, plantId } = useParams();

  const { data: device, isLoading } = useGetDeviceQuery({
    deviceId: deviceId ?? '',
  });

  const { data: plant } = useGetPlantQuery({
    plantId: plantId,
  });

  const isSmartMeter = device?.type === 'SmartMeter';

  return (
    <div className="overview w-full gap-2 overflow-auto px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          {!isMobile && (
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem className="link-underline">
                  <BreadcrumbLink asChild>
                    <Link to="/dashboard">Dashboard</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem className="link-underline">
                  <BreadcrumbLink asChild>
                    <Link to="/plants">Plants</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem className="link-underline">
                  <BreadcrumbLink asChild>
                    <Link to={`/plants/${plantId}`}>{plant?.basicDetails.name}</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>Devices</BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="flex items-center gap-1 font-semibold">
                    <span>{device?.name}</span>
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          )}
          {isMobile && (
            <Button variant="outline" asChild className="size-8 p-0">
              <Link to={`/plants/${plantId}`}>
                <ChevronLeft />
              </Link>
            </Button>
          )}{' '}
          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div className="@container flex flex-col gap-6">
          <div className="flex w-full items-center justify-between">
            <h2 className="h-8 overflow-hidden text-2xl font-semibold text-nowrap text-ellipsis">
              {device?.name}
            </h2>
            {isSmartMeter && deviceId && (
              <SmartMeterMenuPopover
                deviceId={deviceId}
                deviceName={device?.name}
                isLoading={isLoading}
              />
            )}
          </div>
          {device?.type !== 'BMS' && <DefaultDevicePage deviceId={deviceId} />}
          {device?.type === 'BMS' && <BmsDevicePage deviceId={deviceId} />}
        </div>
      </div>
    </div>
  );
};

export default DevicePlant;
